import type { AnchorHTMLAttributes } from "react";
import { ButtonAnchor } from "@/components/UI/ButtonLink";
import type { ButtonAnchorProps } from "@/components/UI/ButtonLink";

const SAFE_EXTERNAL_LINK_PROPS = {
  target: "_blank",
  rel: "noopener noreferrer",
} as const;

type ExternalLinkProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  "href" | "rel" | "target"
> & {
  href: string;
};

type ExternalButtonLinkProps = Omit<
  ButtonAnchorProps,
  "href" | "rel" | "target"
> & {
  href: string;
};

export function ExternalLink({ children, ...rest }: ExternalLinkProps) {
  return (
    <a {...rest} {...SAFE_EXTERNAL_LINK_PROPS}>
      {children}
    </a>
  );
}

export function ExternalButtonLink({
  children,
  ...rest
}: ExternalButtonLinkProps) {
  return (
    <ButtonAnchor {...rest} {...SAFE_EXTERNAL_LINK_PROPS}>
      {children}
    </ButtonAnchor>
  );
}
